import React from "react";
import ReactDOM from "react-dom";
import "mobx-react-lite/batchingForReactDom";
import App from "./app";
import "./layout.scss";
import "./theme.scss";

ReactDOM.render(<App />, document.getElementById("root"));
